var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-6"},[(_vm.loading)?_c('fa-icon',{attrs:{"icon":['far', 'circle-notch'],"size":"3x","spin":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }